import { InjectionToken } from '@angular/core';
import { Exporter } from '../models/exporter';

/**
 * Multi-provider DI token.
 *
 * Cada exporter se registra como:
 *   { provide: EXPORTERS, useExisting: MyExporterService, multi: true }
 *
 * El ExportService los consume todos y aplica RBAC + enrutamiento por id.
 */
export const EXPORTERS = new InjectionToken<Exporter[]>('export.exporters');
